import WelcomeSettings from "./WelcomeSettings";

export default function SettingsContent(props) {

    const {content} = props;

    return (<>{content === undefined ? <WelcomeSettings/> : content}</>);
}